import { render, staticRenderFns } from "./InvestmentApproachChart.vue?vue&type=template&id=0af2dc9c&scoped=true"
import script from "./InvestmentApproachChart.vue?vue&type=script&lang=ts"
export * from "./InvestmentApproachChart.vue?vue&type=script&lang=ts"
import style0 from "./InvestmentApproachChart.vue?vue&type=style&index=0&id=0af2dc9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af2dc9c",
  null
  
)

export default component.exports